import React from "react";
import { useNavigate } from "react-router-dom";

import battery from "../../../assets/battery.webp";
import { exploreSurveyIntentPath } from "../../../configs/ExploreSurveyConfig";
import { pageConfigBySlug } from "../../../services/nav/NavigationService";
import {
  IDashboardBatteryPayload,
  IDashboardTileResult,
} from "../../../services/zeos-api/contracts/Dashboard";
import { DashboardMetricTile } from "../shared/DashboardMetricTile";

interface IProps {
  unlocked: boolean;
  setUnlocked: (unlocked: boolean) => void;
  tileResult?: IDashboardTileResult<IDashboardBatteryPayload>;
  loading?: boolean;
}

export const BatteryStatus = (props: IProps) => {
  const navigate = useNavigate();
  const exploreSlug = pageConfigBySlug("explore")?.slug || "explore";
  const tileResult =
    props.tileResult ??
    ({
      status: "no_asset",
      message: "No battery connection configured for this property.",
      data: null,
    } as IDashboardTileResult<IDashboardBatteryPayload>);

  return (
    <DashboardMetricTile
      tileKey="battery"
      title="Battery"
      image={battery}
      navPath={pageConfigBySlug("battery")?.slug || "battery"}
      unlocked={props.unlocked}
      setUnlocked={props.setUnlocked}
      tileResult={tileResult}
      loading={props.loading}
      lockedCopy={{
        bodyHeading: "SAVE ENERGY & LOWER COSTS",
        bodyContent: "Improve reliability and reduce the effects of blackouts.",
        onExploreClick: () =>
          navigate(exploreSurveyIntentPath(exploreSlug, "battery-storage")),
      }}
      metrics={[
        {
          label: "Stored",
          value: null,
          unit: "kWh",
          tone: "positive",
        },
      ]}
    />
  );
};
